import { forwardRef } from 'react';

const TONES = ['primary', 'secondary', 'accent', 'outline', 'danger', 'ghost', 'icon'];

export const Button = forwardRef(function Button({
  children,
  type = 'button',
  tone = 'primary',
  disabled = false,
  loading = false,
  className,
  block = false,
  ...props
}, ref) {
  const resolvedTone = TONES.includes(tone) ? tone : 'primary';
  return (
    <button
      ref={ref}
      type={type}
      className={['btn', `btn-${resolvedTone}`, block ? 'btn-block' : '', className].filter(Boolean).join(' ')}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...props}
    >
      {loading ? <span className="btn-spinner" aria-hidden="true" /> : null}
      {resolvedTone === 'icon' ? children : <span className="btn-label">{children}</span>}
    </button>
  );
});
